import React from "react";

import { Box, styled } from "@mui/material";
import { LiLink } from "../common/commonComps";
import type { AdminConfig, MpIframeContent } from "../types";

const Wrap = styled(Box)(() => ({
    height: `80px`,
    padding: `140px 0 0`,
    position: `relative`,
    marginBottom: sessionStorage.getItem(`edit`) ? `40px` : 0,
}));

const BottomRail = styled(Box)(() => ({
    height: `60px`,
    position: `absolute`,
    bottom: 0,
    width: `100%`,
    textAlign: `center`,
    borderTop: `1px solid rgb(237, 237, 237)`,
    paddingTop: 15,
}));

const FooterItem = styled(Box)(() => ({
    height: `30px`,
    verticalAlign: `middle`,
    display: `inline-block`,
    margin: `0 60px`,
    cursor: `pointer`,
    color: `#333`,
}));

const Footer = ({ adminConfig }: { adminConfig: AdminConfig }) => (
    <Wrap id="footer">
        <BottomRail>
            {adminConfig?.mall?.content_page_links?.contact_us_url && (
                <LiLink target="_blank" to={adminConfig?.mall?.content_page_links?.contact_us_url}>
                    <FooterItem>Contact Us</FooterItem>
                </LiLink>
            )}
            {adminConfig?.mall?.content_page_links?.privacy_policy_url && (
                <LiLink target="_blank" to={adminConfig?.mall?.content_page_links?.privacy_policy_url}>
                    <FooterItem>Privacy Policy</FooterItem>
                </LiLink>
            )}
            {adminConfig?.mall?.content_page_links?.terms_of_use_url && (
                <LiLink target="_blank" to={adminConfig?.mall?.content_page_links?.terms_of_use_url}>
                    <FooterItem>Terms Of Use</FooterItem>
                </LiLink>
            )}
            {adminConfig?.mall?.content_page_links?.faq_url && (
                <LiLink target="_blank" to={adminConfig?.mall?.content_page_links?.faq_url}>
                    <FooterItem>FAQ</FooterItem>
                </LiLink>
            )}
            {adminConfig?.mall?.content_page_links?.learn_more_url && (
                <LiLink target="_blank" to={adminConfig?.mall?.content_page_links?.learn_more_url}>
                    <FooterItem>Learn More</FooterItem>
                </LiLink>
            )}
            {(adminConfig.mp_iframe_content as MpIframeContent).portal_terms_url && (
                <LiLink
                    target={(adminConfig.mp_iframe_content as MpIframeContent).terms_is_iframe ? `_self` : `_blank`}
                    to={
                        (adminConfig.mp_iframe_content as MpIframeContent).terms_is_iframe
                            ? `/i/portal_terms`
                            : ((adminConfig.mp_iframe_content as MpIframeContent).portal_terms_url as string)
                    }
                >
                    <FooterItem>Terms Of Use</FooterItem>
                </LiLink>
            )}
            {(adminConfig.mp_iframe_content as MpIframeContent).portal_terms_url && (
                <LiLink
                    target={(adminConfig.mp_iframe_content as MpIframeContent).privacy_is_iframe ? `_self` : `_blank`}
                    to={
                        (adminConfig.mp_iframe_content as MpIframeContent).privacy_is_iframe
                            ? `/i/portal_privacy`
                            : ((adminConfig.mp_iframe_content as MpIframeContent).portal_privacy_url as string)
                    }
                >
                    <FooterItem>Privacy Policy</FooterItem>
                </LiLink>
            )}
        </BottomRail>
    </Wrap>
);

export default Footer;
